export default __webpack_public_path__ + "static/walkietalkie-232627a123ce28198a36f8b9730207a4.png";